<!--  -->
<template>
    <div class="message">
        <div class="page-tit">
            <span>留言管理</span>
        </div>
        <div class="message-main">
            <div class="ht_ts">温馨提示：每个网站可以设置不同的表单，留言查看时请切换站点和站点内对应网页查看</div>
            <div class="message-filter-toolbar">
                <div class="message-toolbar-item">
                    <el-select v-model="websiteName" size="small" placeholder="请选择站点" @change="handleChange()" :popper-append-to-body="false">
                        <el-option v-for="item in pageList" :key="item.id" :label="item.projName" :value="item.id"></el-option>
                    </el-select>
                </div>
                <div class="message-toolbar-item">
                    <el-select v-model="formName" size="small" placeholder="请选择留言表单" @change="getMessageInfo" :popper-append-to-body="false">
                        <el-option v-for="(item ,i) in formList" :key="i" :label="item.positionName" :value="item.positionType"></el-option>
                    </el-select>
                </div>
                <div class="message-toolbar-item">
                    <el-date-picker v-model="dateRange" type="daterange" size="small" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                </div>
                <div class="message-toolbar-item">
                    <el-button type="warning" size="small" @click="getMessageInfo">查询</el-button>
                </div>
            </div>
            <div class="message-table">
                <el-table class="zs-table" :data="tableData" style="width: 100%" v-loading="listLoading">
                    <template v-if="tableData.length>0">
                        <el-table-column v-for="item in tableNameData" :key="item.id" :property="item.id" :label="item.fieldName" min-width="100">
                            <template slot-scope="scope">
                                <div class="message-td-txt">
                                    <template v-if="scope.column.property != 'messageTime' && item.fieldType === '2'">
                                        <!-- <el-tooltip class="item" effect="light" :content="scope.row[scope.column.property]" placement="bottom-start">
											<el-button>{{scope.row[scope.column.property]}}</el-button>
                                        </el-tooltip>-->
                                        <div class="message-td-txt-desc" :title="scope.row[scope.column.property]">{{scope.row[scope.column.property]}}</div>
                                    </template>
                                    <template v-else>{{scope.row[scope.column.property]}}</template>
                                </div>
                            </template>
                        </el-table-column>
                    </template>
                </el-table>
            </div>
            <el-pagination background layout="prev, pager, next" :page-size="6" @current-change="handleCurrentChange" :total="total" hide-on-single-page></el-pagination>
        </div>
    </div>
</template>

<script>
import {
    mapActions,
    mapGetters,
    mapMutations,
    mapState
} from 'vuex'
import PageApi from '@/api/page.api'
import TemplateApi from '@/api/template.api'
import moment from 'moment'
export default {
    name: '',
    components: {},
    data () {
        return {
            listLoading: false,
            websiteName: '',
            formName: '',
            dateRange: [],
            pageList: [],
            formList: [],
            total: 0,
            pageNum: 1,
            pageSize: 10,
            tableNameData: [],
            tableData: [],
        }
    },
    created () {
        this.getFirstFormData()
        this.getPageList()
    },
    computed: {

        ...mapState(['globals']),
        ...mapState(['projListData']),
        ...mapGetters('user', ['userInfo']),
    },
    watch: {},
    methods: {
        async getFirstFormData () {
            const params = {
                uid: this.userInfo.uid
            }
            const { data } = await TemplateApi.findFirstFormData(params)
            if (data.isSuccess) {
                this.websiteName = data.data.projectId
                this.formName = data.data.positionType
                this.handleChange(this.formName)

            } else {
                console.log('站点获取失败')
            }

        },
        async getPageList () {
            const params = {
                userId: this.userInfo.uid,
                status: 0,
                pageSize: 1000,
                pageNum: 1
            }
            const { data } = await PageApi.projlist(params)
            if (data.isSuccess) {
                this.pageList = data.data.list.filter(item => {
                    item.projName = item.projectDomain ? 'http://' + item.projectDomain : this.globals.baseUrl + '/page/projhtml?&projId=' + item.id
                    return item.experience != '1'
                })
                // this.pageList = this.pageList.filter(item => {
                // 	return item.experience != '1'
                // })
            } else {
                console.log('站点获取失败')
            }

            // this.pageList = this.projListData
        },
        async handleChange (name) {
            const params = {
                projectId: this.websiteName
            }
            const { data } = await TemplateApi.findPositionTypeName(params)
            if (data.isSuccess) {
                this.formList = data.data
                if (!name) {
                    this.formName = this.formList.length > 0 ? this.formList[0].positionType : ''
                } else {
                    this.formName = name
                }
                this.getMessageInfo()
            } else {
                console.log('表单列表获取失败')
            }
        },
        handleCurrentChange (val) {
            this.pageNum = val
            this.getMessageInfo()
        },
        async getMessageInfo () {
            this.listLoading = true
            const params = {
                projectId: this.websiteName,
                positionType: this.formName
            }
            const { data } = await TemplateApi.tableNameList(params)

            if (data.isSuccess) {
                let tableList = data.data
                this.tableNameData = tableList.filter(item => {
                    return item.display === '1'
                })
                this.tableNameData = this.tableNameData.map(item => {
                    item.id = String(item.id)
                    return item
                })
                this.tableNameData.push({ fieldName: '留言时间', id: 'messageTime' })
                await this.getMessagelist()
            } else {
                console.log('表单列表获取失败')
            }
        },
        async getMessagelist () {
            const params = {
                projectId: this.websiteName,
                positionType: this.formName,
                pageNum: this.pageNum,
                pageSize: this.pageSize
            }
            if (this.dateRange.length > 0) {
                params.beginDate = moment(this.dateRange[0]).format('YYYY/MM/DD HH:mm:ss')
                params.endDate = moment(this.dateRange[1]).format('YYYY/MM/DD HH:mm:ss')
            }
            const { data } = await TemplateApi.leaveMessageList(params)
            this.listLoading = false
            if (data.isSuccess) {
                this.tableData = data.data.list
                this.total = data.data.total
            } else {

                this.tableData = []
                this.total = 0
                console.log('表单列表数据获取失败')
            }
        }





    },
}
</script>
<style lang='scss' scoped>
.message {
    min-width: 1400px;
}
.message-main {
    background: #fff;
    padding: 38px 16px 72px;
    border-radius: 4px;
}

.ht_ts {
    height: 40px;
    padding: 0 20px;
    margin-bottom: 20px;
    background: rgba(249, 192, 176, 0.33);
    border-radius: 2px;
    font-size: 12px;
    line-height: 40px;
    color: $colorD;
}
.message-filter-toolbar {
    display: flex;
    margin-bottom: 18px;
}
.message-toolbar-item {
    margin-right: 20px;
}
.message-td-txt {
    max-height: 90px;
    overflow: auto;
}
.message-td-txt {
    .el-button {
        width: 100%;
        max-height: 72px;
        display: block;
        border: 0;
        line-height: 16px;
        background: none;
        text-align: left;
        white-space: break-spaces;
        span {
            display: block;
            line-height: 16px;
            overflow: hidden;
        }
    }
}
.message-td-txt-desc {
    // text-overflow: -o-ellipsis-lastline;
    // overflow: hidden;
    // text-overflow: ellipsis;
    // display: -webkit-box;
    // -webkit-line-clamp: 3;
    // line-clamp: 3;
    // -webkit-box-orient: vertical;
    line-height: 30px;
    white-space: pre-wrap;
}
</style>
